import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    accordionSummaryContainer: {
        display: "flex",
        width: "100%",
        borderBottom: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        justifyContent: "space-between",
        alignItems: "center",
    },
    accordionSummary: {
        flexDirection: "row-reverse",
        "& .MuiAccordionSummary-content": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(90deg)",
        },
    },
    accordionSummaryTitle: {
        "&.MuiTypography-root": {
            marginLeft: "5px",
            color: theme.palette.info.main,
            fontSize: "18px",
            fontWeight: 400,
            fontFamily: "Open Sans",
        },
    },
    accordion: {
        padding: "0 20px 20px 20px",
        width: "100%",
    },
    accordionDetails: {
        marginTop: "20px",
        "&.MuiAccordionDetails-root": {
            padding: 0,
        },
    },
    addMachineButton: {
        "&.MuiButtonBase-root": {
            color: theme.palette.info.main,
            fontWeight: 700,
            fontSize: "12px",
            fontFamily: "Open Sans",
        },
    },
    addProductionLineButton: {
        "&.MuiButtonBase-root": {
            color: theme.palette.info.main,
            fontWeight: 700,
            fontSize: "12px",
            fontFamily: "Open Sans",
            width: "230px",
        },
    },
    moreIcon: {
        color: theme.palette.info.main,
        fontWeight: 400,
    },
    moreIconCard: {
        color: theme.palette.text.primary,
        fontWeight: 400,
    },
}));
